import { render, staticRenderFns } from "./ClientOrderList.vue?vue&type=template&id=e5cb75b6&scoped=true"
import script from "./ClientOrderList.vue?vue&type=script&lang=js"
export * from "./ClientOrderList.vue?vue&type=script&lang=js"
import style0 from "./ClientOrderList.vue?vue&type=style&index=0&id=e5cb75b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cb75b6",
  null
  
)

export default component.exports